import React from 'react';
import { CareProgressBadgeType } from '../types';
import InProgressBadge from './InProgressBadge';
import ScriptWrittenBadge from './ScriptWrittenBadge';
import CompletedBadge from './CompletedBadge';
import NoDocumentBadge from './NoDocumentBadge';

type BadgeTypeProps =
  | {
      type: CareProgressBadgeType.COMPLETED;
      completedDates: string[];
      startedDates?: never;
      scriptWrittenDates?: never;
    }
  | {
      type: CareProgressBadgeType.IN_PROGRESS;
      startedDates: string[];
      completedDates?: never;
      scriptWrittenDates?: never;
    }
  | {
      type: CareProgressBadgeType.SCRIPT_WRITTEN;
      scriptWrittenDates: string[];
      completedDates?: never;
      startedDates?: never;
    }
  | {
      type: CareProgressBadgeType.NO_DOCUMENT;
      scriptWrittenDates?: never;
      completedDates?: never;
      startedDates?: never;
    };
type CareProgressBadgeProps = {
  id: string;
  onClick?: () => void;
  columnName: string;
} & BadgeTypeProps;

const CareProgressBadge = ({
  onClick,
  id,
  type,
  columnName,
  completedDates,
  startedDates,
  scriptWrittenDates,
}: CareProgressBadgeProps) => {
  const mappedBadge = React.useMemo(() => {
    switch (type) {
      case CareProgressBadgeType.SCRIPT_WRITTEN:
        return (
          <ScriptWrittenBadge scriptWrittenDates={scriptWrittenDates} id={id} />
        );
      case CareProgressBadgeType.COMPLETED:
        return (
          <CompletedBadge
            completedDates={completedDates}
            id={id}
            columnName={columnName}
          />
        );
      case CareProgressBadgeType.IN_PROGRESS:
        return (
          <InProgressBadge
            startedDates={startedDates}
            id={id}
            columnName={columnName}
          />
        );
      case CareProgressBadgeType.NO_DOCUMENT:
        return <NoDocumentBadge id={id} column={columnName} />;
      default:
        return null;
    }
  }, []);
  return mappedBadge;
};

export default CareProgressBadge;
